
import { NgcCookieConsentModule, NgcCookieConsentConfig } from 'ngx-cookieconsent';
import { environment } from '../../environments/environment';

export const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: environment.metaUrl,
  },
  position: 'bottom-right',
  theme: 'edgeless',
  palette: {
    popup: {
      background: 'rgba(0,0,0,0.5)',
      text: '#ffffff',
      link: '#ffffff'
    },
    button: {
      background: 'rgba(255,255,255,0)',
      text: '#ffffff',
      border: 'transparent'
    }
  },
  type: 'info',
  layout: 'my-custom-layout',
  layouts: {
    'my-custom-layout': '{{messageObject}}{{close}}'
  },
  elements: {
    messageObject: `
      <p>
      {{message}} <a href="{{href}}" routerLink="{{href}}" target="_blank">{{link}}</a>
      </p>
    `,
    close: '<span aria-label="dismiss cookie message" tabindex="0" class="cc-close">{{dismiss}}</span>',
  },
  content: {
    message: 'We use cookies to help the site run smoothy, learn more ',
    dismiss: '&#xf00d;',
    deny: 'Refuse cookies',
    link: 'here',
    href: environment.metaUrl + 'terms',
    policy: 'Cookie Policy'
  }
};
